import { Pipe, PipeTransform } from '@angular/core';

import { pickTranslatedName, TranslatableName } from 'src/app/utils';

@Pipe({
  name: 'translatedName'
})
export class TranslatedNamePipe implements PipeTransform {
  transform(
    value: TranslatableName | null | undefined,
    lang: string | null
  ): string {
    return pickTranslatedName(value, lang);
  }
}
